const SITE_VISIT_ASSIGNMENT_TYPE = 1;
const ASSIGNED_PARTY_CONTRACTOR = 1;
const ASSIGNED_PARTY_SUPERVISOR = 3;

export const INITIAL_SITE_VISIT_PERFORMER = {
  SUPERVISOR: "SolarentSupervisor",
  CONTRACTOR: "Contractor",
};

export const PERFORMER_TYPE_OPTIONS = [
  { value: INITIAL_SITE_VISIT_PERFORMER.SUPERVISOR, label: "ناظر سولارنت" },
  { value: INITIAL_SITE_VISIT_PERFORMER.CONTRACTOR, label: "پیمانکار" },
];

export const VALIDATION_MESSAGES = {
  performerTypeRequired: "نوع مجری بازدید اولیه را انتخاب کنید.",
  assigneeRequired: "مجری بازدید اولیه را انتخاب کنید.",
  mismatch: "مجری انتخاب‌شده با نوع بازدید انتخابی هم‌خوانی ندارد.",
  inactiveAssignee: "مجری انتخاب‌شده فعال یا مجاز به انجام بازدید نیست.",
};

export const CREDIT_VALIDATION_PENDING_MESSAGE =
  "پس از تأیید اعتبارسنجی متقاضی توسط لندتک، امکان ارجاع بازدید فعال می‌شود.";

export const ASSIGNMENT_LOCKED_AFTER_ACCEPTANCE_MESSAGE =
  "پس از پذیرش ارجاع توسط ناظر، امکان تغییر مجری/ناظر بازدید برای کارشناس وجود ندارد.";

export const PROJECT_ASSIGNMENT_STATUS = {
  ASSIGNED: 1,
  ACCEPTED: 2,
  REJECTED: 3,
  CANCELED: 4,
  COMPLETED: 5,
  SUPERSEDED: 6,
};

export const isOperatorSiteVisitAssignmentEditable = (assignment) => {
  if (!assignment) return true;
  const status = Number(
    assignment.projectAssignmentStatus ?? assignment.ProjectAssignmentStatus
  );
  return status === PROJECT_ASSIGNMENT_STATUS.ASSIGNED;
};

export const pickActiveSiteVisitAssignment = (assignments) => {
  const list = Array.isArray(assignments) ? assignments : [];
  return (
    list
      .filter(
        (item) =>
          Number(item?.projectAssignmentType ?? item?.ProjectAssignmentType) ===
          SITE_VISIT_ASSIGNMENT_TYPE
      )
      .filter((item) => item?.isActive !== false && item?.IsActive !== false)
      .sort((left, right) => {
        const leftTime = new Date(
          left?.assignedAt ?? left?.AssignedAt ?? 0
        ).getTime();
        const rightTime = new Date(
          right?.assignedAt ?? right?.AssignedAt ?? 0
        ).getTime();
        return rightTime - leftTime;
      })[0] ?? null
  );
};

export const resolveCanAssignSiteVisit = (gate) =>
  Boolean(gate?.canAssignSiteVisit ?? gate?.CanAssignSiteVisit);

export const resolveLendingCreditValidationApproved = (gate) =>
  Boolean(
    gate?.lendingCreditValidationApproved ?? gate?.LendingCreditValidationApproved
  );

export const resolvePerformerTypeFromAssignment = (assignment) => {
  if (!assignment) return "";
  const partyType = Number(
    assignment.assignedPartyType ?? assignment.AssignedPartyType
  );
  if (partyType === ASSIGNED_PARTY_SUPERVISOR) {
    return INITIAL_SITE_VISIT_PERFORMER.SUPERVISOR;
  }
  if (partyType === ASSIGNED_PARTY_CONTRACTOR) {
    return INITIAL_SITE_VISIT_PERFORMER.CONTRACTOR;
  }
  return "";
};

export const resolveAssigneeIdFromAssignment = (assignment, performerType) => {
  if (!assignment) return "";
  if (performerType === INITIAL_SITE_VISIT_PERFORMER.SUPERVISOR) {
    const id = assignment.supervisorInfoId ?? assignment.SupervisorInfoId;
    return id != null ? String(id) : "";
  }
  if (performerType === INITIAL_SITE_VISIT_PERFORMER.CONTRACTOR) {
    const id = assignment.contractorInfoId ?? assignment.ContractorInfoId;
    return id != null ? String(id) : "";
  }
  return "";
};

export const getAssigneeFieldLabel = (performerType) => {
  if (performerType === INITIAL_SITE_VISIT_PERFORMER.SUPERVISOR) {
    return "ناظر بازدید اولیه";
  }
  if (performerType === INITIAL_SITE_VISIT_PERFORMER.CONTRACTOR) {
    return "پیمانکار بازدید اولیه";
  }
  return "مجری بازدید اولیه";
};

export const getPerformerTypeLabel = (performerType) =>
  PERFORMER_TYPE_OPTIONS.find((item) => item.value === performerType)?.label ??
  "—";

export const formatContractorLookupLabel = (item) => {
  if (!item) return "—";
  const title = String(item.title ?? item.Title ?? "").trim();
  const company = String(item.companyName ?? item.CompanyName ?? "").trim();
  const displayName = String(item.displayName ?? item.DisplayName ?? "").trim();
  if (displayName) return displayName;
  if (company && title) {
    if (title.includes(company) || title.includes("—") || title.includes("-")) {
      return title;
    }
    return `${company} — ${title}`;
  }
  return title || company || item?.name || item?.Name || "—";
};

export const lookupOptionTitle = (options, id) => {
  if (id == null || id === "") return "—";
  const match = (Array.isArray(options) ? options : []).find(
    (item) => String(item?.id ?? item?.Id) === String(id)
  );
  return formatContractorLookupLabel(match);
};

export const buildInitialSiteVisitAssignmentPayload = ({
  requestId,
  performerType,
  assigneeId,
  note,
}) => ({
  requestId: Number(requestId),
  performerType,
  assigneeId: Number(assigneeId),
  note: note?.trim() || null,
});

export const validateInitialSiteVisitForm = ({ performerType, assigneeId }) => {
  if (!performerType) {
    return VALIDATION_MESSAGES.performerTypeRequired;
  }
  if (!assigneeId) {
    return VALIDATION_MESSAGES.assigneeRequired;
  }
  return null;
};

export const clearAssigneeOnPerformerTypeChange = ({
  previousPerformerType,
  nextPerformerType,
  assigneeId,
}) => {
  if (!nextPerformerType || nextPerformerType === previousPerformerType) {
    return assigneeId;
  }
  return "";
};
